import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex flex-wrap flex-row gap-4 items-center p-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "font-semibold text-sm" }
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = { class: "flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-12 w-0" }, null, -1)
const _hoisted_8 = { class: "flex flex-col w-full relative" }
const _hoisted_9 = { class: "flex flex-col overflow-auto" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "" }, null, -1)
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "flex flex-row items-center text-sm" }
const _hoisted_13 = { class: "flex flex-row items-center text-xs" }

import { ref, watch } from "vue";
import { ShareholderService } from "@/services/shareholder/ShareholderService";


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageUserSelector',
  props: {
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["setUsers"],
  setup(__props, { emit }) {





const shareholderService = new ShareholderService();

const showList = ref<boolean>(false);
const occurence = ref<string>("");
const users = ref([]);
const fetchedUsers = ref([]);

const fetchUsers = async () => {
  const { data, success} = await shareholderService.getShareholders(
    undefined,
    undefined,
    undefined,
    occurence.value
  );

  if (success && data) {
   fetchedUsers.value = data;
  }
};

const addUser = async (user: object) => {
  if (
    users.value.length == 0 ||
    !users.value.find((item) => user.id == item.id)
  ) {
    users.value.push(user);
  }
};

const deleteUser = async (user: object) => {
  users.value = users.value.filter((item) => user.id != item.id);
};

watch(users, () => {
  emit("setUsers", users.value);
});

watch(users.value, () => {
  emit("setUsers", users.value);
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[2] || (_cache[2] = ($event: any) => (showList.value = __props.disabled ? false : true)),
    class: _normalizeClass([
      __props.disabled ? 'bg-gray-100' : 'bg-white',
      'rounded-md border border-gray-300',
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
        return (_openBlock(), _createElementBlock("div", {
          key: user.id,
          class: "flex flex-row px-4 py-1 text-sm gap-4 items-center rounded-full text-gray-800 border bg-gray-100 border-gray-300"
        }, [
          _createElementVNode("div", {
            onClick: ($event: any) => (deleteUser(user)),
            class: "flex flex-row items-center w-full gap-4"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(user.name), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(user.email), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_mdicon, { name: "close" })
            ])
          ], 8, _hoisted_2)
        ]))
      }), 128)),
      _hoisted_7
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass([
          showList.value ? '' : 'hidden',
          'absolute z-50 top-2 bg-white shadow-lg flex flex-col max-h-48 border border-gray-300 rounded-md w-full',
        ])
      }, [
        _withDirectives(_createElementVNode("input", {
          onInput: _cache[0] || (_cache[0] = ($event: any) => (fetchUsers(_ctx.ocurence))),
          placeholder: "Buscar... ",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((occurence).value = $event)),
          class: "w-full p-2"
        }, null, 544), [
          [_vModelText, occurence.value]
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fetchedUsers.value, (user) => {
            return (_openBlock(), _createElementBlock("div", {
              key: user.id,
              class: "flex flex-col w-full"
            }, [
              _hoisted_10,
              _createElementVNode("div", {
                onClick: ($event: any) => (
                addUser({
                  id: user.id,
                  name: user.businessName && user.businessName?.trim() != '' ? user.businessName : user.accountOwnerName ,
                  email: user.accountEmail,
                })
              ),
                class: "flex flex-col gap-1 p-2 w-full hover:bg-gray-200 transition-all"
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(user.businessName && user.businessName?.trim() != '' ? user.businessName : user.accountOwnerName), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(user.accountEmail), 1)
              ], 8, _hoisted_11)
            ]))
          }), 128))
        ])
      ], 2)), [
        [_directive_click_outside, () => (showList.value = false)]
      ])
    ])
  ], 2))
}
}

})